export default "__VITE_ASSET__X4e0K3lWu31WoqFRl$w6gw__"